var Modal = /** @class */ (function () {
    function Modal(el) {
        if (!el) {
            return;
        }
        this.el = el;
        this.dialog = el.querySelector('.ac-modal__dialog');
        this.initEvents();
    }
    Modal.prototype.initEvents = function () {
        var _this = this;
        var self = this;
        document.addEventListener('keydown', function (e) {
            var keyName = e.key;
            if (!_this.isOpen()) {
                return;
            }
            if ('Escape' === keyName) {
                _this.close();
            }
        });
        var dismissButtons = this.el.querySelectorAll('[data-dismiss="modal"], .ac-modal__dialog__close');
        if (dismissButtons.length > 0) {
            dismissButtons.forEach(function (b) {
                b.addEventListener('click', function (e) {
                    e.preventDefault();
                    self.close();
                });
            });
        }
        this.el.addEventListener('click', function (e) {
            if (e.target.classList.contains('ac-modal')) {
                self.close();
            }
        });
    };
    Modal.prototype.isOpen = function () {
        return this.el.classList.contains('-active');
    };
    Modal.prototype.close = function () {
        this.onClose();
        this.el.classList.remove('-active');
    };
    Modal.prototype.open = function () {
        var _this = this;
        //short delay in order to allow bubbling events to bind before opening
        setTimeout(function () {
            _this.onOpen();
            _this.el.removeAttribute('style');
            _this.el.classList.add('-active');
        });
    };
    Modal.prototype.destroy = function () {
        this.el.remove();
    };
    Modal.prototype.onClose = function () {
    };
    Modal.prototype.onOpen = function () {
    };
    return Modal;
}());
export default Modal;
